module.exports = __webpack_public_path__ + "static/Resilient-Supply-Chain-3b7f6ff269105d3538ebab16c82f5fec.jpg";